// extracted by mini-css-extract-plugin
module.exports = {"mmboostpage":"style_mmboostpage__2UcOC","mmboostpage__calculator":"style_mmboostpage__calculator__3lmhN","mmboostpage__button":"style_mmboostpage__button__34pv5"};